/**
 * Created by mauget on 5/12/17.
 */

import $ from 'jquery';
import BaseControlView from 'BaseControlView';
import constants       from 'Constants';
import listService       from 'ListService';
import focusController from 'FocusController';

//=====================================================================
//
// Base class of non-visible controls. Those render at the bottom of
// the form. This base class specializes that rendering. Repainting
// an existing control shoujld not alter its position. Painting a new
// conrol should append it to the right-end of the row of "invisible"
// control (visible during designing).
//
// Lou Mauget, May 12, 2017
//
//=====================================================================
class AssetBaseView extends BaseControlView {
    initialize( opts ) {
        super.initialize( opts );

        this.$el = $(this.el);
        return this;
    }

    render() {
        this.$el.empty();
        const $id = $('#' + this.model.attributes.id);
       if  ( $id.length ) {
            $id.replaceWith(this.template(this.model.toJSON()));
        } else {
            //Applying same approach as used inside render of BaseControlView, for assets was working fine first time when dropped  control
            //but when switch between behaviors and desktop (timer and sound) where not rendered
            // Note: Don't use this.$el. Desktop could have been closed and rebuilt while control held in listService.
            $(constants.PAGE_ASSETS_ID).append(this.template(this.model.toJSON()));           
        }
    }
}

export default AssetBaseView;